export default "__VITE_ASSET__7bf77bbe__"